export class LocalError extends Error {
  constructor(msg = 'Local') {
    super(msg);
  }
}
